import axios from '@/axios';

const profile = () => axios.get('/auth');

export { profile };
